/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{94A431B1-AEEB-40AA-9B83-CB6B4192E382}",
  "jssAppName": "portalthird",
  "defaultLanguage": "nl-NL",
  "virtualFolder": "/delaportaal"
};